// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7869) return "static/chunks/7869-d32ac9938dd50497.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"659":"c9a05579c66d01f6","693":"10824af970d99d78","1274":"bb77e944fef49250","1655":"e9232a74c2d7b829","2316":"5a67c3e2d39ad845","4406":"8a74d0d884c7bc98","5493":"2f27fea1e8ab7819"}[chunkId] + ".js";
};